import { ContentSideNavButton, LeftPaneContent, LinkSideNavButton, RightDrawerButton, SideNavButton, SideNavButtonAlignment } from "@mydocma/app-container";
import { MmSideNavBarButtonsEnum } from "./mm-sidenavbar-buttons.enum"
import { ConfigPermissionEnum } from "@docma-mm-core/permission/config-permission.enum";
import { MmStructureLeftPaneComponent } from "../mm-filter/structure/mm-structure-left-pane/mm-structure-left-pane.component";
import { MmLayoutLeftPaneComponent } from "../mm-filter/layout/layout-left-pane/layout-left-pane.component";
import { routeToPath } from "../mm-routing/mm-routes.map";
import { MmRoutesEnum } from "../mm-routing/mm-routes.enum";


export const leftPaneContentMap = new Map<string, LeftPaneContent>([
  ['structure', new LeftPaneContent({ id: 'structure', componetType: MmStructureLeftPaneComponent })],
  ['layout', new LeftPaneContent({ id: 'layout', componetType: MmLayoutLeftPaneComponent})],
]);


export const buttonsMap: { [id: string]: { group: MmSideNavBarButtonsEnum, button: SideNavButton, isExpandedOnInit?: boolean, isBackButton?: boolean, hasPermission?: boolean } } = {
  [MmSideNavBarButtonsEnum.FilterGroup]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({ id: MmSideNavBarButtonsEnum.FilterGroup, icon: 'visibility', expanded: true }),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.FilterStructure]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({ active: true, id: MmSideNavBarButtonsEnum.FilterStructure, parentId: MmSideNavBarButtonsEnum.FilterGroup, icon: 'account_tree', content: leftPaneContentMap.get('structure') })
  },

  [MmSideNavBarButtonsEnum.FilterLayout]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({ id: MmSideNavBarButtonsEnum.FilterLayout, parentId: MmSideNavBarButtonsEnum.FilterGroup, icon: 'view_column', content: leftPaneContentMap.get('layout') })
  },

  [MmSideNavBarButtonsEnum.Faults]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new LinkSideNavButton({ active: true, id: MmSideNavBarButtonsEnum.Faults, icon: 'rule' })
  },

  [MmSideNavBarButtonsEnum.Plans]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new LinkSideNavButton({ active: true, id: MmSideNavBarButtonsEnum.Plans, icon: '_plan-view' })
  },

  [MmSideNavBarButtonsEnum.MessageCenter]: {
    group: MmSideNavBarButtonsEnum.MainGroup, button: new RightDrawerButton({
      id: 'task-dashboard',
      alignment: SideNavButtonAlignment.bottom,
      icon: '_megaphone',
      tooltip: 'MM.sidebar.messageCenter',
      text: 'MM.sidebar.messageCenter',
      contentId: 'task-dashboard',
      badgeCount: 0
    })
  },

  [MmSideNavBarButtonsEnum.UserSettingsBackToProject]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.UserSettingsBackToProject, icon: 'chevron_left', hidden: true }),
    isBackButton: true
  },

  [MmSideNavBarButtonsEnum.UserSettingsGroup]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.UserSettingsGroup, icon: '_user-settings', hidden: true, expanded: true, active: false }),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.UserSettingsVariables]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.UserSettingsVariables, parentId: MmSideNavBarButtonsEnum.UserSettingsGroup, icon: '_variable-user' })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsGroup]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_project-config', hidden: false, expanded: true, active: false }),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsBackToMain]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsBackToMain, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: 'chevron_left', hidden: true })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsCompanies, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_company-config', hidden: true }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsCrafts, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_crafts', hidden: true }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectVariables]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectVariables, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_variable-project', hidden: true }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_project-specifics-1', hidden: true }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: '_project-specifics-2', hidden: true }),
    hasPermission: false
  }

};

export const urlToButtonMap: { [path: string]: { group: MmSideNavBarButtonsEnum, content: MmSideNavBarButtonsEnum } } = {
  [routeToPath.get(MmRoutesEnum.faults)]: { group: MmSideNavBarButtonsEnum.MainGroup, content: MmSideNavBarButtonsEnum.Faults },
  [routeToPath.get(MmRoutesEnum.faults) + '?view=plan']: { group: MmSideNavBarButtonsEnum.MainGroup, content: MmSideNavBarButtonsEnum.Plans },
  [routeToPath.get(MmRoutesEnum.user_variables)]: { group: MmSideNavBarButtonsEnum.UserSettingsGroup, content: MmSideNavBarButtonsEnum.UserSettingsVariables },
  [routeToPath.get(MmRoutesEnum.project_companies)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectSettingsCompanies },
  [routeToPath.get(MmRoutesEnum.project_crafts)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectSettingsCrafts },
  [routeToPath.get(MmRoutesEnum.project_variables)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectVariables },
  [routeToPath.get(MmRoutesEnum.project_type1)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1 },
  [routeToPath.get(MmRoutesEnum.project_type2)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2 },
};

export const idToUrlMap = new Map<string, string>([
  [MmSideNavBarButtonsEnum.Faults, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.Plans, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.UserSettingsBackToProject, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.UserSettingsVariables, routeToPath.get(MmRoutesEnum.user_variables)],

  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies, routeToPath.get(MmRoutesEnum.project_companies)],
  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts, routeToPath.get(MmRoutesEnum.project_crafts)],
  [MmSideNavBarButtonsEnum.ProjectVariables, routeToPath.get(MmRoutesEnum.project_variables)],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1, routeToPath.get(MmRoutesEnum.project_type1)],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2, routeToPath.get(MmRoutesEnum.project_type2)],
]);


export const idToTranslationKey = new Map<string, string>([
  [MmSideNavBarButtonsEnum.FilterGroup, 'MM.sidebar.view.group'],
  [MmSideNavBarButtonsEnum.FilterStructure, 'MM.sidebar.view.structure'],
  [MmSideNavBarButtonsEnum.FilterLayout, 'MM.layout.layout'],
  [MmSideNavBarButtonsEnum.Faults, 'MM.fault.faultPlural'],
  [MmSideNavBarButtonsEnum.Plans, 'MM.plan.plans'],
  [MmSideNavBarButtonsEnum.UserSettingsBackToProject, 'MM.sidebar.userSettings.backToProject'],
  [MmSideNavBarButtonsEnum.UserSettingsGroup, 'MM.sidebar.userSettings.group'],
  [MmSideNavBarButtonsEnum.UserSettingsVariables, 'MM.sidebar.userSettings.variables'],

  [MmSideNavBarButtonsEnum.ProjectSettingsGroup, 'MM.sidebar.projectSettings.group'],
  [MmSideNavBarButtonsEnum.ProjectSettingsBackToMain, '<'],
  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies, 'MM.sidebar.projectSettings.companies'],
  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts, 'MM.sidebar.projectSettings.crafts'],
  [MmSideNavBarButtonsEnum.ProjectVariables, 'MM.sidebar.projectSettings.variables'],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1, 'MM.sidebar.projectSettings.userdefineds1'],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2, 'MM.sidebar.projectSettings.userdefineds2'],

  [MmSideNavBarButtonsEnum.MessageCenter, 'MM.sidebar.messageCenter'],
]);
